import { Marked } from 'marked';
const marked = new Marked();
export function renderMarkdown(content) {
  const result = marked.parse(content, { mangle: false, headerIds: false, breaks: true });
  return result;
}
export function removeHtmlTags(html) {
    if (html != null && html != "") {
		var re1 = new RegExp("<.+?>|&.+?;","g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
		var msg = html.replace(re1,""); //执行替换成空字符
		//msg = msg.replace(/\s/g,""); //去掉所有的空格（中文空格、英文空格都会被替换）
		msg = msg.replace(/[\r\n]/g,""); //去掉所有的换行符
		return msg //获文本文字内容的前100个字符
    } else {
		return ''
    }
}

export function checkPlatform() {
	var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
		return 'android'
	}
	if (isiOS) {
		return 'ios'
	}
}